module.exports = __webpack_public_path__ + "static/media/arrow-left-hover.2050144a.svg";